import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';

const addActiveDrawerPaneMutator: (paneId: string, tabId: string) => void = mutatorAction(
    'addActiveDrawerPane',
    (paneId: string, tabId: string): void => {
        getStore().activePanes.set(tabId, paneId);
    }
);
export default addActiveDrawerPaneMutator;
